import React from 'react';
import Image from 'next/image';
import { generateDirectusSrc } from '@/helpers/image';

const Media = ({
  type,
  file,
  index,
  colspan,
}: {
  type: string;
  file: {
    id: string;
    title: string;
  };
  index: number;
  colspan?: number;
}) => {
  const imageSize = (type: string | null) => {
    if (type === 'image_contain' || type === 'Image Contain') {
      return 'object-contain';
    }
    if (type === 'image_cover') {
      return 'object-cover';
    }
    if (type === 'image_fill') {
      return 'object-fill';
    }
    return 'object-cover';
  };

  const sizes =
    colspan === 12
      ? '(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 700px'
      : '(max-width: 768px) 100vw, (max-width: 1200px) 25vw, 350px';

  const imageWidth = colspan === 12 ? 700 : 450;

  return (
    <>
      {type === 'video' ? (
        <video className={`w-full rounded-xl`} controls>
          <source
            src={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/${file?.id}`}
            type="video/ogg"
          />
        </video>
      ) : (
        <Image
          src={generateDirectusSrc(file?.id)}
          alt={file?.title || 'Product image'}
          title={file?.title}
          className={`w-full bg-[#F6F6F6] h-full ${imageSize(type)} rounded-[10px]`}
          width={imageWidth}
          height={imageWidth}
          sizes={sizes}
          priority={index < 4}
          unoptimized={true}
        />
      )}
    </>
  );
};

export default Media;
